export default "__VITE_ASSET__Bw9D2JZq__"